module.exports = "/images/arrow-blue.png?a09b243dede8c0b838819d27847a9935";